import { makeStyles } from '@material-ui/core';
import ButtonTab from './ButtonTab';

const useStyles = makeStyles({
  tabs: (props: { size: 'small' | 'medium' }) => ({
    width: 'fit-content',
    display: 'flex',
    alignItems: 'center',
    gap: props.size === 'small' ? '0.25rem' : '0.5rem',
    padding: props.size === 'small' ? '0.5rem' : '0.5rem 0.75rem',
    borderRadius: 4,
    backgroundColor: 'rgb(145 148 152 / 20%)',
    boxShadow: 'inset 0px 0px 4px 0px rgba(0, 0, 0, 0.17)',

    '& hr': {
      width: '1px',
      height: '16px',
      margin: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.17)',
      border: 'none',
    },

    '& .MuiButton-label': {
      textTransform: 'none',
    },
  }),
});

type Props = {
  size?: 'small' | 'medium';
  tabs: { id: string; label: string; value: string; disabled?: boolean; count?: number }[];
  currentTabId: string;
  onTabChange: (tabId: string) => void;
};

export default function TabsController({ size = 'medium', tabs, currentTabId, onTabChange }: Props) {
  const classes = useStyles({ size });

  return (
    <section className={classes.tabs}>
      {tabs.map((tab) => (
        <ButtonTab
          key={tab.id}
          size={size}
          disabled={tab.disabled}
          label={tab.label}
          isActive={currentTabId === tab.value}
          value={tab.value}
          count={tab.count}
          onClick={onTabChange}
        />
      ))}
    </section>
  );
}
